import { Container, makeStyles } from "@material-ui/core";
import { useSelector } from "react-redux";

import { CircularProggressIndicator } from "../components-atoms/CircularProggressIndicator";
import { OrderItem } from "../components-molecules";
import InfiniteScroll from "react-infinite-scroll-component";
import { LoadMoreIndicator } from "../components-atoms/LoadMoreIndicator";
import { NoResultsFound } from "../components-molecules/NoResultsFound";
import { IOrderItemSource } from "../components-molecules/OrderItem";

export const ReadyForCollectionOrders = (props: any) => {
  const classes = useStyles();
  const queuedOrdersLoading = useSelector(
    (state: any) => state.queuedOrders.loading
  );
  const queuedOrdersData = useSelector((state: any) => state.queuedOrders.data);

  const getDataLength = () => {
    let count = 0;
    count = queuedOrdersData.Deliveries.length;
    return count;
  };

  const OrderList = () => {
    return (
      <div className={classes.pt40}>
        {queuedOrdersData.Deliveries.map((item: any) => (
          <OrderItem key={item.Id} data={item} onClick={props.onClick} source={IOrderItemSource.ReadyForCollection} />
        ))}
      </div>
    );
  };

  return (
    <InfiniteScroll
      style={{ overflow: "hidden" }}
      dataLength={getDataLength()}
      next={props.loadMoreData}
      hasMore={getDataLength() < queuedOrdersData.TotalCount}
      scrollThreshold={0.99}
      loader={<LoadMoreIndicator />}
    >
      <Container className={classes.component}>
        {queuedOrdersLoading && getDataLength() === 0 ? (
          <CircularProggressIndicator />
        ) : getDataLength() === 0 ? (
          <NoResultsFound
            query={props.query}
            filterApplied={props.filterApplied}
          />
        ) : (
          <OrderList />
        )}
      </Container>
    </InfiniteScroll>
  );
};
const useStyles = makeStyles({
  component: {
    display: "flex",
    flexDirection: "column",
    paddingLeft: 0,
    paddingRight: 0,
  },
  noRecordsFound: {
    display: "flex",
    paddingLeft: "24px",
    flexDirection: "column",
  },
  noSearchResults: {
    display: "flex",
    paddingLeft: 24,
    paddingTop: 40,
    flexDirection: "column",
  },
  pt40: {
    paddingTop: 40,
  },
});
